import React, { useRef, useState } from 'react'
import { Col, Container, Form, Row, Button } from 'react-bootstrap'
import axios from 'axios'
import { useNavigate } from 'react-router-dom';
// import emailjs from 'emailjs-com';

export default function HomeContact() {
    const [validated, setValidated] = useState(false);
    const [loading, setLoading] = useState(false);
    const [values, setValues] = useState({
        fullName: "",
        mobile: "",
        email: "",
        comment: ""
    })
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setValues({ ...values, [name]: value, });
        // setErrors(RegisterValidation(values));
    };

    const Submit = () => {

        let formData = new FormData();

        formData.append("FullName", values.fullName);
        formData.append("Email", values.email);
        formData.append("Mobile", values.mobile);
        formData.append("Comment", values.comment);

        setLoading(true);
        const api = "https://www.actionforms.io/e/r/samudayahcontact";

        axios.post(api, formData)
            .then((response) => {
                console.log(response)
                if (response.status === 200) {
                    setLoading(false);
                    navigate("/success");
                } else {
                    console.log(response)
                    setLoading(false);
                }
            })
            .catch((err) => {
                console.log("err", err)
                setLoading(false);
            })
    }

    const handleSubmit = (event) => {
        const form = event.currentTarget;
        event.preventDefault();

        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            Submit();
            // sendEmail();
        }
        setValidated(true);
    };

    return (
        <Container className="mt-2" >
            <Container className="home-contact-container" >
                <Row className='mb-5 ' >
                    <Col className='home_contact_title'>
                        <div> Make an Appointment Today ! </div>
                    </Col>
                </Row>
                <Row className='home_contact_row' >
                    <Col xl={6} lg={6} md={10} sm={10} xs={10} className="home-contact-one-col" >
                        <Row> <h3 className="home-contact-one-title-one text-center"> Contact Form </h3> </Row>
                        <Form className="mb-1 justify-content-center contact-form" noValidate validated={validated} onSubmit={handleSubmit}>
                            <Row className="mb-1 justify-content-center">
                                <Form.Group className="p-2" as={Col} xl={10} controlId="validationCustom01">
                                    <Form.Label>Full Name</Form.Label>
                                    <Form.Control
                                        required
                                        type="text"
                                        placeholder="Enter Name"
                                        name="fullName"
                                        value={values.fullName}
                                        onChange={handleChange}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Please provide a valid First Name.
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Row>
                            <Row className="mb-1 justify-content-center">
                                <Form.Group className="p-2" as={Col} xl={10} controlId="validationCustom01">
                                    <Form.Label>Phone Number</Form.Label>
                                    <Form.Control
                                        required
                                        type="text"
                                        placeholder="Enter Mobile Number"
                                        name="mobile"
                                        value={values.mobile}
                                        onChange={handleChange}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Please provide a valid First Name.
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Row>
                            <Row className="mb-2 justify-content-center">
                                <Form.Group className="p-2" as={Col} xl={10} controlId="validationCustom02">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control
                                        required
                                        type="text"
                                        placeholder="Enter Email"
                                        name="email"
                                        value={values.email}
                                        onChange={handleChange}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Please provide a valid Email.
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Row>
                            <Row className="mb-3 justify-content-center">
                                <Form.Group as={Col} xl={10} controlId="validationCustom04">
                                    <Form.Label>Comment</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        placeholder="Enter Comment"
                                        required
                                        name="comment"
                                        value={values.comment}
                                        onChange={handleChange}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Please provide a valid Comment.
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Row>
                            <Row className="mb-3 justify-content-center">
                                <Col xl={10} >
                                    <Button className="contact-one-btn justify-content-center" type="submit">Submit</Button>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
            </Container>
        </Container>
    )
}
